import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import RegisterSchool from "@/pages/RegisterSchool";
import SubmitEntry from "@/pages/SubmitEntry";
import RulesPrizes from "@/pages/RulesPrizes";
import Contact from "@/pages/Contact";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/register" element={<RegisterSchool />} />
          <Route path="/submit" element={<SubmitEntry />} />
          <Route path="/success" element={<Success />} />
          <Route path="/rules" element={<RulesPrizes />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
